import $ from 'jquery';
import 'magnific-popup';
import '../Language/magnific-popup'

(function () {
    var lightboxes = $('a.lightbox');
    if (lightboxes.length === 0) {
        return;
    }

    lightboxes.magnificPopup({
        type: 'image',
        gallery: {
            enabled: true
        },
        zoom: {
            enabled: true,
            easing: 'ease-in-out'
        }
    });
})();

(function () {
    var $gallery = $('.gallery-lightboxes');
    if ($gallery.length === 0) {
        return;
    }

    $gallery.each(function () {
        $(this).magnificPopup({
            delegate: 'a.gallery-lightbox',
            type: 'image',
            gallery: {
                enabled: true
            },
            zoom: {
                enabled: true,
                easing: 'ease-in-out'
            }
        });
    })
})();
